// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/GTEestiBold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/AvenirBook.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/AvenirBlack.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/AvenirOblique.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*******************************************************
 *                                                     *
 *                VIAJES TEIDE                         *
 *                                                     *
 *        developed: Javier Vega Martinez              *
 *        contact: info@emdbwebprojects.com            *
 *        copyright - 2014-2024                        *
 *                                                     *
 *******************************************************/
/* width */
/* fonts */
@font-face {
  font-family: GTEestiBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@font-face {
  font-family: AvenirBook;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
@font-face {
  font-family: AvenirBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
@font-face {
  font-family: AvenirOblique;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
/* debug */
.debug-j1FVo {
  background-color: #ff7f50;
}
.debug2-IQCCj {
  background-color: #6495ed;
}
.cartSummary-OIrZL {
  container: cartSummary / inline-size;
  width: 100%;
  height: auto;
  margin-top: 60px;
  border-radius: 20px;
  border-inline: 1px solid #E1E1E1;
  font-family: AvenirBook;
  font-size: 1em;
}
.cartSummary-OIrZL .header-rbjjs {
  width: 100%;
  padding: 20px 0px;
  background-color: #E1E1E1;
  border-radius: 20px 20px 0px 0px;
}
.cartSummary-OIrZL .header-rbjjs h3 {
  margin: 0px 20px;
  font-size: 1.125em;
  font-family: AvenirBlack;
}
.cartSummary-OIrZL .cartEmpty-mb8CE {
  margin: 30px 20px;
}
.cartSummary-OIrZL .summaryItems-DcA7Z {
  margin-bottom: 20px;
  font-family: AvenirBook;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j {
  margin: 10px 5%;
  font-size: 1em;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .title-MNp3R {
  margin-bottom: 10px;
  font-family: AvenirBlack;
  font-size: 1em;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .date-KHd8Q {
  margin-bottom: 20px;
  font-size: 0.9375em;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .contents-LdHA0 .content-xcKqX {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .contents-LdHA0 .content-xcKqX .pax-Jinsy {
  flex: 6;
  font-size: 0.9375em;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .contents-LdHA0 .content-xcKqX .paxprice-noGzn {
  flex: 4;
  font-size: 0.9375em;
  text-align: right;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .line-c8jxN {
  width: 100%;
  margin: 10px 0px 10px 0px;
  border-bottom: 1px dashed #333333;
  height: 5px;
  font-size: 0px;
  line-height: 0px;
}
.cartSummary-OIrZL .summaryItems-DcA7Z .summaryItem-EdU5j .total-fvPa_ {
  width: 100%;
  text-align: right;
  font-size: 0.9375em;
}
.cartSummary-OIrZL .summaryTotals-ncwX5 {
  width: 100%;
  padding: 20px 0px 20px 0px;
  border-radius: 0px 0px 20px 20px;
  background-color: #E1E1E1;
  font-family: AvenirBook;
}
.cartSummary-OIrZL .summaryTotals-ncwX5 .content-xcKqX {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.cartSummary-OIrZL .summaryTotals-ncwX5 .content-xcKqX .text-Aqc66 {
  flex: 7;
  padding-left: 20px;
  font-size: 1em;
}
.cartSummary-OIrZL .summaryTotals-ncwX5 .content-xcKqX .price-nVcwi {
  flex: 3;
  padding-right: 15px;
  font-size: 1em;
  text-align: right;
  white-space: nowrap;
}
.cartSummary-OIrZL .summaryTotals-ncwX5 .line-c8jxN {
  box-sizing: border-box;
  width: calc(100% - 40px);
  margin: 20px;
  border-bottom: 1px dashed;
  height: 1px;
  font-size: 0px;
  line-height: 0px;
}
.cartSummary-OIrZL .summaryTotals-ncwX5 .content-xcKqX:nth-child(5) {
  font-size: 1em;
  font-family: AvenirBlack;
}
@container cartSummary (max-width: 250px) {
  .header-rbjjs {
    font-size: 0.9375em;
  }
  .summaryItems-DcA7Z {
    font-size: 0.9375em;
  }
  .summaryTotals-ncwX5 {
    font-size: 0.9375em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/VTCartSummary/VTCartSummary.module.less","webpack://./src/assets/css/theme.less"],"names":[],"mappings":"AAAA;;;;;;;;wDAQwD;AACxD,UAAU;AACV,UAAU;ACwBV;EAAY,wBAAA;EAA0B,4CAAA;ADpBtC;ACqBA;EAAY,uBAAA;EAAyB,4CAAA;ADjBrC;ACkBA;EAAY,wBAAA;EAA0B,4CAAA;ADdtC;ACeA;EAAY,0BAAA;EAA4B,4CAAA;ADXxC;AACA,UAAU;ACiBV;EAAQ,yBAAA;ADdR;ACeA;EAAS,yBAAA;ADZT;AA/BA;EAAa,oCAAA;EAAsC,WAAA;EAAY,YAAA;EAAc,gBAAA;EAAiB,mBAAA;EAAqB,gCAAA;EAAsC,uBAAA;ECsCvJ,cAAA;ADGF;AAzCA;EACU,WAAA;EAAY,iBAAA;EAAmB,yBAAA;EAA8B,gCAAA;AA8CvE;AA/CA;EAEO,gBAAA;ECoCL,kBAAA;EDpCuC,wBAAA;AAkDzC;AApDA;EAIa,iBAAA;AAmDb;AAvDA;EAMgB,mBAAA;EAAoB,uBAAA;AAqDpC;AA3DA;EAOiB,eAAA;EC+Bf,cAAA;ADyBF;AA/DA;EAQa,mBAAA;EAAoB,wBAAA;EC8B/B,cAAA;AD8BF;AApEA;EASY,mBAAA;EC6BV,mBAAA;ADkCF;AAxEA;EAWiB,aAAA;EAAe,SAAA;EAAU,mBAAA;AAkE1C;AA7EA;EAYe,OAAA;EC0Bb,mBAAA;ED1BqC,uBAAA;EAAyB,mBAAA;AAuEhE;AAnFA;EAaoB,OAAA;ECyBlB,mBAAA;EDzB0C,iBAAA;AA2E5C;AAxFA;EAgBY,WAAA;EAAa,yBAAA;EAA2B,iCAAA;EAAuC,WAAA;EAAa,cAAA;EAAgB,gBAAA;AAgFxH;AAhGA;EAiBa,WAAA;EAAa,iBAAA;ECqBxB,mBAAA;AD+DF;AArGA;EAoBiB,WAAA;EAAY,0BAAA;EAA2B,gCAAA;EAAkC,yBAAA;EAA+B,uBAAA;AAwFzH;AA5GA;EAqBa,aAAA;EAAc,SAAA;EAAW,mBAAA;AA4FtC;AAjHA;EAsBY,OAAA;EAAQ,kBAAA;ECgBlB,cAAA;ADgFF;AAtHA;EAuBa,OAAA;EAAQ,mBAAA;ECenB,cAAA;EDfwD,iBAAA;EAAmB,mBAAA;AAsG7E;AA7HA;EAyBU,sBAAA;EAAuB,wBAAA;EAA0B,YAAA;EAAa,yBAAA;EAA2B,WAAA;EAAa,cAAA;EAAgB,gBAAA;AA6GhI;AAtIA;ECsCE,cAAA;EDZyC,wBAAA;AAgH3C;AA5GA;EACE;ICOA,mBAAA;EDwGA;EA9GA;ICMA,mBAAA;ED2GA;EAhHA;ICKA,mBAAA;ED8GA;AACF","sourcesContent":["@import \"../../assets/css/theme\";\n\n.cartSummary{container: cartSummary / inline-size; width:100%; height: auto; margin-top:60px; border-radius: 20px; border-inline: 1px solid @colorgris1; font-family:AvenirBook; .font-base(16);\n  .header{width:100%; padding: 20px 0px; background-color:@colorgris1; border-radius: 20px 20px 0px 0px;\n    h3{margin: 0px 20px; .font-base(18); font-family:AvenirBlack;}\n  }\n  .cartEmpty{margin: 30px 20px;}\n\n  .summaryItems{margin-bottom:20px; font-family:AvenirBook;\n    .summaryItem{margin:10px 5%; .font-base(16);\n      .title{margin-bottom:10px; font-family:AvenirBlack; .font-base(16);}\n      .date{margin-bottom:20px; .font-base(15);}\n      .contents{\n        .content{display: flex; gap:10px; margin-bottom:10px;\n          .pax{flex:6; .font-base(15); text-overflow: ellipsis; white-space: nowrap;}\n          .paxprice{flex:4; .font-base(15); text-align: right;}\n        }\n      }\n      .line{width: 100%; margin: 10px 0px 10px 0px; border-bottom: 1px dashed @colorgris4; height: 5px; font-size: 0px; line-height: 0px;}\n      .total{width: 100%; text-align: right; .font-base(15);}\n    }\n  }\n  .summaryTotals{width:100%; padding:20px 0px 20px 0px; border-radius: 0px 0px 20px 20px; background-color: @colorgris1; font-family:AvenirBook;\n    .content{display:flex; gap: 10px; margin-bottom: 10px;\n      .text{flex:7; padding-left: 20px; .font-base(16); }\n      .price{flex:3; padding-right: 15px; .font-base(16); text-align: right; white-space: nowrap;}\n    }\n    .line{box-sizing:border-box; width: calc(100% - 40px); margin:20px; border-bottom: 1px dashed; height: 1px; font-size: 0px; line-height: 0px;}\n    .content:nth-child(5){.font-base(16);  font-family:AvenirBlack;}\n  }\n}\n\n@container cartSummary (max-width: 250px) {\n  .header {.font-base(15);}\n  .summaryItems {.font-base(15);}\n  .summaryTotals{.font-base(15);}\n}\n\n\n","/*******************************************************\n *                                                     *\n *                VIAJES TEIDE                         *\n *                                                     *\n *        developed: Javier Vega Martinez              *\n *        contact: info@emdbwebprojects.com            *\n *        copyright - 2014-2024                        *\n *                                                     *\n *******************************************************/\n\n//VARS\n\n@colorverde1: #99CC33;  //verde 1\n@colorverde2: #009933;  //verde 2\n@colorverde3: #BEE266;  //verde 3\n@colorazul1: #33CCFF;   //azul 1\n@colorrosa1: #FF6698;   //rosa 1\n\n@colorgris1: #E1E1E1;   //Gris background footer\n@colorgris2: #999999;   //Gris text\n@colorgris3: #666666;   //Gris text\n@colorgris4: #333333;   //Gris text\n@colorgris5: #5D5D5D;\n\n/* width */\n@width-space:20px;\n@width-column:40px;\n@width-content: 1100px;\n@width-total: @width-content + 20px;\n@width-min:400px;\n\n/* fonts */\n@em:16px;\n\n@font-face {font-family: GTEestiBold; src: url('../fonts/GTEestiBold.otf'); }\n@font-face {font-family: AvenirBook; src: url('../fonts/AvenirBook.otf'); }\n@font-face {font-family: AvenirBlack; src: url('../fonts/AvenirBlack.ttf'); }\n@font-face {font-family: AvenirOblique; src: url('../fonts/AvenirOblique.otf'); }\n\n.font-base(@sizeValue) {\n  font-size: unit(( @sizeValue / @em ), em);\n}\n\n/* debug */\n.debug {background-color:#ff7f50;}\n.debug2 {background-color:#6495ed ;}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debug": `debug-j1FVo`,
	"debug2": `debug2-IQCCj`,
	"cartSummary": `cartSummary-OIrZL`,
	"header": `header-rbjjs`,
	"cartEmpty": `cartEmpty-mb8CE`,
	"summaryItems": `summaryItems-DcA7Z`,
	"summaryItem": `summaryItem-EdU5j`,
	"title": `title-MNp3R`,
	"date": `date-KHd8Q`,
	"contents": `contents-LdHA0`,
	"content": `content-xcKqX`,
	"pax": `pax-Jinsy`,
	"paxprice": `paxprice-noGzn`,
	"line": `line-c8jxN`,
	"total": `total-fvPa_`,
	"summaryTotals": `summaryTotals-ncwX5`,
	"text": `text-Aqc66`,
	"price": `price-nVcwi`
};
export default ___CSS_LOADER_EXPORT___;
